import React from "react";
import './BasicLayoutNew.css';

// {window.location.pathname === '/login' ? return import './BasicLayoutNew.css' : }
// if (window.location.pathname){
//   import './BasicLayoutNew.css';
// }else{
//   import './BasicLayout.css';
// }

export default ({ children }) => (
  <div className="vertical-layout vertical-menu-modern blank-page navbar-floating footer-static">
    {children}
  </div>
);
